const digest = '4255c2d88d3739ee9834bfb3074653995c47e73fab409d26a0f4b2d7bd47b62e';
const css = `._hotelDescription_lnone_1 p{margin-bottom:.5rem}._hotelDescription_lnone_1 p:last-child{margin-bottom:0}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'hotelDescription': '_hotelDescription_lnone_1' };
export const hotelDescription = '_hotelDescription_lnone_1';
export { css, digest };